import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useEntityNavigate as useNavigate } from '../../navigation/navigation'
import EntityForm from '../../components/EntityForm'
import { Button } from '../../components/ui'
import './Company.css'

function ContractEdit() {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isNew = location.pathname.endsWith('/new') || id === 'new'
  const editId = isNew ? null : id
  const clientId = location.state?.clientId || undefined
  const objectId = location.state?.objectId || undefined
  const context = (clientId || objectId) ? { clientId, objectId } : {}

  return (
    <div className="company-page">
      <div className="page-header">
        <Button variant="ghost" onClick={() => navigate(isNew ? '/company/contracts' : `/contract/${editId}`)} className="btn-back">
          ← Назад
        </Button>
      </div>
      <EntityForm
        entityType="contracts"
        entityId={editId}
        context={context}
        title={isNew ? 'Новый договор' : 'Редактирование договора'}
      />
    </div>
  )
}

export default ContractEdit
